export enum OsasScoreColor {
    gray = '#DBD5D0',
    green = '#00D06A',
    orange = '#FA6400',
    red = '#E33B3B',
    yellow = '#F7B500',
}
